import { render, staticRenderFns } from "./HomePublic.vue?vue&type=template&id=54feafb0&"
import script from "./HomePublic.vue?vue&type=script&lang=js&"
export * from "./HomePublic.vue?vue&type=script&lang=js&"
import style0 from "./HomePublic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports